<script>
	import fetchNode from "../helpers/FetchNode.js";
    import MultiSelect from '../components/MultiSelect.svelte';
    
	export let selected = undefined;
    export let node;
    export let clause = false;

    export let placeholder = '';
    
    export let labelFieldName = 'name';
    export let valueFieldName = 'id';

    let listOpen = false;

    let params = clause ? {limit:1000,where:JSON.stringify(clause)} : {limit:1000};

    const request = fetchNode(node,params).then(items => items.map(item=> {
    	return {
    		value: item[valueFieldName],
    		label: item[labelFieldName]}
    }));


</script>
{#await request then items}
    <MultiSelect bind:value={selected} {placeholder} >
        {#each items as item}
            <option value="{item.value}">{item.label}</option>
        {/each}
    </MultiSelect>
{/await}

<style>
.themed {
    --border: 1px solid #D0CFCB;
    --borderRadius: 0;
}
</style>
